import React from 'react';

import * as S from './styles';

const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Macacão, Bold Strap, R$ 3.950.
          <br />
          Luvas, Moun, R$ 229.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide2 };
